import { DataModelBuilder, isSameData, SerializationContext, SerializedData } from '../../models/dto/dto.js';
import { LocalizedPhotoReference } from '../../models/serializable/localized-photo-reference.js';
import { LocalizedString } from '../../models/serializable/localized-string.js';
import { MapUtils } from '../../utility/map-utils.js';
import { RenderableComponent } from '../core/component.js';

export class ResponsiveImageComponent extends RenderableComponent {
  static readonly TYPE_ID: string = '50e33874effc44b3b559adfdbbcfd7b3';

  // Same as the `DEFAULT_RENDER_ORDER` of `ResponsiveImageComponent`
  static readonly DEFAULT_RENDER_ORDER: number = 14;

  constructor(
    public readonly titles: LocalizedString,
    public readonly photos: LocalizedPhotoReference | null,
    public readonly renderOrder: number,
    public readonly isRenderingEnabled: boolean,
  ) {
    super();
  }

  get $typeId(): string {
    return ResponsiveImageComponent.TYPE_ID;
  }

  get $removable(): boolean {
    return true;
  }

  static fromMap(context: SerializationContext, map: SerializedData): ResponsiveImageComponent {
    return new ResponsiveImageComponent(
        context.fromData<LocalizedString>(MapUtils.get<SerializedData>(map, 'titles')),
        context.fromDataOrNull<LocalizedPhotoReference>(MapUtils.getOrNull<SerializedData>(map, 'photos')),
        MapUtils.get<number>(map, 'renderOrder'),
        MapUtils.get<boolean>(map, 'isRenderingEnabled'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'titles': context.toData(this.titles),
      'photos': context.toDataOrNull(this.photos),
      'renderOrder': this.renderOrder,
      'isRenderingEnabled': this.isRenderingEnabled,
    };
  }

  clone(): this {
    return new ResponsiveImageComponent(
        this.titles.clone(),
        this.photos?.clone() ?? null,
        this.renderOrder,
        this.isRenderingEnabled
    ) as this;
  }

  isSame(other: ResponsiveImageComponent): boolean {
    if(other === this) {
      return true;
    }

    return isSameData(other.titles, this.titles) &&
      isSameData(other.photos, this.photos) &&
      other.renderOrder === this.renderOrder &&
      other.isRenderingEnabled === this.isRenderingEnabled;
  }
}

export class ResponsiveImageComponentBuilder extends DataModelBuilder<ResponsiveImageComponent> {
  build(context: SerializationContext, map: SerializedData): ResponsiveImageComponent {
    return ResponsiveImageComponent.fromMap(context, map);
  }
}
